import { isAlphanumericAllSpecialCharacters } from "../../../functions/validations";
import { GenericTable } from "../../utility/common/TransactionComponents/GenericTable";

const getRowError = (error, minField, maxField) => {
  const hasError = error[minField]?.status || error[maxField]?.status;
  const errorMessage = error[minField]?.message || error[maxField]?.message;
  return { hasError, errorMessage };
};

export const WPS_ThicknessTable = ({ headerObj, error, isReadonly, handleChange, setError, rows }) => {
  const columns = [
    { type: 'label', field: "label", width: '600px', className:"text-start error-head"},
    { header: 'Min', field: 'Min', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters,inputWidth: "100px" ,className:"WpsInput-md"},
    { header: 'Max', field: 'Max', type: 'input', maxLength: 6, validator: isAlphanumericAllSpecialCharacters,inputWidth: "100px" ,className:"WpsInput-md"}
  ];

  const tableData = {
    rows: rows.map(row => ({
      label: { value: row.label },
      Min: { value: headerObj?.[row.minField], field: row.minField, error: error[row.minField]?.status || false },
      Max: { value: headerObj?.[row.maxField], field: row.maxField, error: error[row.maxField]?.status || false },
      ...getRowError(error, row.minField, row.maxField)
    }))
  };

console.log("tableDAta",tableData,error)

  return (
<>

      
<div
  className="thickness_title"
  style={{
    height: "33px",
    fontSize: "14px",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "flex-end", // align text to the right
    alignItems: "center", // center vertically
    paddingRight: "342px", // space from the extreme right
   
  }}
>
As {headerObj?.wld_TRQ_Type}
</div>

 
    <GenericTable
      data={tableData}
      columns={columns}
      isReadonly={isReadonly}
      handleChange={handleChange}
      setError={setError}

    />
    </>
  );
};